import { getAxiosInstanceApi } from "./api";
import { cachiosInstance } from "./cacheApi";

/**
 * ----------------------------
 *  Qrcode routes
 * ----------------------------
 */
export const getQrcode = (query, callback, force = false) => {
  cachiosInstance.get(`/q-r-code?${query}`, { force })
    .then(response => {
      const data = response.data;
      callback(true, data);
    }).catch(error => {
      callback(false, error?.response?.data);
    });
};
export const getSingleQrcode = (QRCodeUUID, callback) => {
  cachiosInstance.get(`/q-r-code-uuid/${QRCodeUUID}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error?.response?.data);
    });
};
export const deleteQrcode = (qrcodeId, callback) => {
  getAxiosInstanceApi().delete(`/q-r-code/${qrcodeId}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error?.response?.data);
    });
};
export const newQrcode = (query, callback) => {
  getAxiosInstanceApi().post(`/q-r-code?${query}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error?.response?.data);
    });
};
export const updateQrcode = (qrcodeId, query, callback) => {
  getAxiosInstanceApi().put(`/q-r-code/${qrcodeId}?${query}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error?.response?.data);
    });
};